











import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-volume',

})
export default class IVolume extends Vue {

  @Prop({type: [Boolean], default: false}) protected mute!: boolean

}

